module.exports = __webpack_public_path__ + "static/media/workero@3x.7ef59330.png";